<template>
        <RouterView :key="bookKey" />
</template>

<script setup lang="ts">
        import { computed } from "vue"
        import { useRoute } from "vue-router"

        const route = useRoute()
        const bookKey = computed(() => String(route.meta.bookId ?? route.params.bookId ?? route.name))
</script>

//2